import { environments } from '@sunrun/ui-product-selector';

const hostNameEnvMapping = {
  'qualify.sunrun.com': environments.PRODUCTION,
  'majstg-product-selector.sunrun.com': environments.STAGE,
};

const getEnv = (url) => hostNameEnvMapping[url] || environments.STAGE;

export default getEnv;